// ============================================
// usePageView — fire a page view once per mount.
// ============================================
// Usage:
//   import { usePageView } from '../hooks/usePageView';
//   ...
//   usePageView('verify');           // in HomePage
//   usePageView('creators-portal');  // in CreatorsPanel
// ============================================

import { useEffect } from 'react';
import { trackPageView, TrackedPage } from '../lib/analytics';

export function usePageView(page: TrackedPage): void {
    useEffect(() => {
        trackPageView(page);
        // The tracker itself de-dupes identical page+path, so re-mounts are safe.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);
}

export default usePageView;